/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * filterregel-project-edit.component.ts
 * Gegenereerd met Junie (AI), 29-09-2025
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Editorcomponent voor project-regels.
 */

import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {FilterregelEditComponent} from './filterregel-edit.component';
import {FiltertoolProjectregel} from '../../../services/filtertool/regels/filtertool-projectregel';
import {FiltertoolRegelTypeNamen} from '../../../services/filtertool/filtertool-regels';
import {FilterregelActiesComponent} from './filterregel-acties.component';

/**
 * Editor voor projectregels met een eenvoudige naam-bewerking en verwijderknop.
 */
@Component({
  standalone: true,
  selector: 'filterregel-project-edit',
  templateUrl: './filterregel-project-edit.component.html',
  styleUrls: ['./filterregel-project-edit.component.scss', './filterregel-editors.scss'],
  imports: [FilterregelActiesComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterregelProjectEditComponent extends FilterregelEditComponent<FiltertoolProjectregel> {
  // Inputs (properties)
  @Input({ required: true }) override regel!: FiltertoolProjectregel;

  // Properties
  /** Mapping met label/omschrijving per regeltype voor weergave. */
  public readonly regelTypeNamen = FiltertoolRegelTypeNamen;

  // Constructor
  constructor() { super(); }

  // Public methods
  /**
   * Past de naam van de regel aan in-place en emit optioneel een wijzig-event voor dirty-state.
   */
  onNaamInput(naam: string): void {
    if (!this.regel) { return; }
    this.regel.naam = naam;
    this.wijzig.emit(this.regel);
  }
}
